import { create } from "zustand";
import { ActionedType } from "../../../operations/store/ManifestoStore";
import {
  ActionedTypeDefault,
} from "../../../../common/models/StoreDefaultModel";
import dayjs from "dayjs";

type HolidayStore = {
  list: Array<any>;
  totalItems: number;
  pageState: any;
  actioned: ActionedType | null;
  setList: (cont: any) => void;
  setPageState: (cont: any) => void;
  setActioned: (act: ActionedTypeDefault | null) => void;

  resetPageState: () => void;
};

const initialPageState = {
  page: 1,
  itemsPerPage: 10,
  "order[date]": "asc",
  "date[after]": `${dayjs().year()}-01-01`,
  "date[before]": `${dayjs().year()}-12-31`,
};

const initialPageStateCalendar = {
  page: 1,
  pagination: false,
  "date[after]": `${dayjs().year()}-01-01`,
  "date[before]": `${dayjs().year()}-12-31`,
};

export const useHolidayStore = create<HolidayStore>((set) => ({
  list: [],
  totalItems: 0,
  pageState: initialPageState,
  actioned: null,
  setList: (data) =>
    set(() => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),

  setPageState: (data) => set(() => ({ pageState: data })),
  resetPageState: () => set(() => ({ pageState: initialPageState })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
}));

export const useHolidayCalendarStore = create<HolidayStore>((set) => ({
  list: [],
  totalItems: 0,
  pageState: initialPageStateCalendar,
  actioned: null,
  setList: (data) =>
    set(() => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),

  setPageState: (data) => set(() => ({ pageState: data })),
  resetPageState: () => set(() => ({ pageState: initialPageStateCalendar })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
}));
